import { render, staticRenderFns } from "./DocumentOriginalLocationField.vue?vue&type=template&id=397aca44&scoped=true"
import script from "./DocumentOriginalLocationField.vue?vue&type=script&lang=js"
export * from "./DocumentOriginalLocationField.vue?vue&type=script&lang=js"
import style0 from "./DocumentOriginalLocationField.vue?vue&type=style&index=0&id=397aca44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397aca44",
  null
  
)

export default component.exports